import { render, staticRenderFns } from "./AccountVerification.vue?vue&type=template&id=0a8eef3c&scoped=true"
import script from "./AccountVerification.vue?vue&type=script&lang=js"
export * from "./AccountVerification.vue?vue&type=script&lang=js"
import style0 from "./AccountVerification.vue?vue&type=style&index=0&id=0a8eef3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8eef3c",
  null
  
)

export default component.exports